export const theme = {
  colors: {
    primary: "#c5a115",
    backLight: "#fef0b6f0",
    text: "#000",
    bacgroundNav: "#eee",
    bacgroundFooter: "#eee",
    allRightsFooter: "#666",
  },
};
